define("shared/utils/constants/linkinbio-block-styles", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.parseBoxShadow = _exports.SHAPES = _exports.OUTLINES = _exports.BOX_SHADOWS = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const parseBoxShadow = css => {
    return css.split('#')[0];
  };
  _exports.parseBoxShadow = parseBoxShadow;
  const BOX_SHADOWS = _exports.BOX_SHADOWS = [{
    name: 'linkinbio.blocks.style.config.block.box_shadow.none',
    id: 'none',
    svg: 'lib-btn-shadow-none',
    css: () => 'none'
  }, {
    name: 'linkinbio.blocks.style.config.block.box_shadow.soft',
    id: 'soft',
    svg: 'lib-btn-shadow-soft',
    css: color => `rgba(0, 0, 0, 0.3) 3px 3px 5px, ${color} 3px 3px 5px`
  }, {
    name: 'linkinbio.blocks.style.config.block.box_shadow.hard',
    id: 'hard',
    svg: 'lib-btn-shadow-hard',
    css: color => `rgba(0, 0, 0, 0.3) 5px 5px, ${color} 5px 5px`
  }];
  const OUTLINES = _exports.OUTLINES = [{
    name: 'linkinbio.blocks.style.config.block.outline.outline',
    id: 'outline',
    svg: 'minus',
    css: 'transparent'
  }, {
    name: 'linkinbio.blocks.style.config.block.outline.solid',
    id: 'solid',
    svg: 'lib-btn-style-solid',
    css: 'var(--btn-style-solid)'
  }];
  const SHAPES = _exports.SHAPES = [{
    name: 'linkinbio.blocks.style.config.block.shape.round_corners',
    id: 'round-corners',
    svg: 'lib-btn-round-corner',
    css: '5px'
  }, {
    name: 'linkinbio.blocks.style.config.block.shape.round_sides',
    id: 'round-sides',
    svg: 'lib-btn-round-side',
    css: '30px'
  }, {
    name: 'linkinbio.blocks.style.config.block.shape.sharp_corners',
    id: 'sharp-corners',
    svg: 'lib-btn-sharp-corner',
    css: '0'
  }];
});